import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { OAuthError, OAuthParams, OAuthState } from '../../model'
import { confirmAccessCheckout, fetchOAuthCode } from './actions'
import { isPortalApiError, OAUTH_ACCESS_DENIED_ERROR } from '@afterpaytouch/portal-api'

export const oAuthInitialState: OAuthState = {
  consumerEmailId: '',
}

const oAuthSlice = createSlice({
  name: 'oAuth',
  initialState: oAuthInitialState,
  reducers: {
    setOAuthParams(state: OAuthState, { payload }: PayloadAction<OAuthParams>): OAuthState {
      return {
        ...state,
        ...payload,
      }
    },
    setOAuthError(state: OAuthState, { payload }: PayloadAction<OAuthError | undefined>): OAuthState {
      return {
        ...state,
        error: payload,
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(confirmAccessCheckout.fulfilled, (state, { payload }) => {
        state.clientName = payload.clientName
        state.scopeAndDescription = payload.scopeAndDescription
        state.consumerEmailId = payload.consumerEmailId
        state.error = undefined
      })
      .addCase(confirmAccessCheckout.rejected, (state, { payload }) => {
        state.error = isPortalApiError(payload) ? payload : OAUTH_ACCESS_DENIED_ERROR
      })
      .addCase(fetchOAuthCode.rejected, (state, { payload }) => {
        state.error = isPortalApiError(payload) ? payload : OAUTH_ACCESS_DENIED_ERROR
      })
  },
})

export const { setOAuthParams, setOAuthError } = oAuthSlice.actions

export default oAuthSlice.reducer
